export function vibrate() {
    try {
        navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
    
        if (navigator.vibrate) {
            // vibration API supported
            navigator.vibrate([100]);
        } else {
            console.log('No vibration');
        }
    } catch(err) {
        console.log(err);
    }
}
